import { jsx as e } from "react/jsx-runtime";
import { memo as r } from "react";
import { Form as m } from "antd";
import { u as i } from "../styled-components.browser.esm-3eb04950.js";
import n from "./AdditionalDetailSelector.js";
const h = ({ additionalDetail: t, children: o }) => /* @__PURE__ */ e(d, { children: /* @__PURE__ */ e(a, { name: t.textKey, children: o }) }), x = r(({ additionalDetail: t, ...o }) => t.type && /* @__PURE__ */ e(n, { additionalDetail: t, ...o })), a = i(m.Item)`
  margin-bottom: 0;
  width: 100%;
`, d = i.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  `;
export {
  x as AdditionalDetailField,
  h as AdditionalDetailWrapper
};
//# sourceMappingURL=AdditionalDetail.js.map
